import styled from 'styled-components';

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
`;

const HeaderStyled = styled.p`
  color: #ffffff;
  font-weight: 600;
  font-size: 20px;
  margin-top: 50px;
`;

const SubHeaderStyled = styled.p`
  color: #b3a6ba;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 50px;
`;

const BodyStyled = styled.div`
  color: #2d1441;
  font-size: 18px;
  font-weight: 500;
  margin: 50px 0px;
  max-width: 60%;
  text-align: center;
  p {
    margin-bottom: 25px;
  }
`;

const AltBodyStyled = styled(BodyStyled)`
  text-align: justify;
`;

const WarningStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  svg {
    margin: 0px 10px;
  }
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #7c6d89;
    max-width: 55%;
  }
`;

const ButtonWrapperStyled = styled.div`
  margin-top: 20px;
`;

export {
  ContainerStyled,
  HeaderStyled,
  SubHeaderStyled,
  BodyStyled,
  AltBodyStyled,
  WarningStyled,
  ButtonWrapperStyled,
};
